module.exports = __webpack_public_path__ + "static/media/white-card.a5d79e6b.png";